<template>
    <div class="mx-auto">
            <b-row class="d-flex justify-content-between">
                <b-col>
                    <b-button @click="$emit('voltar')" variant="secondary" id="btnVoltar">
                        <i class="fa fa-arrow-left"></i>
                        Voltar
                    </b-button>

                    <CompBotaoExibirOcultarColuna
                            :fields="fields"
                            :showColunms="showColunms"
                            :texto-botao="'Colunas'"
                            @toggleColuna="toggleColuna"
                            class="ml-2"
                            cssClass="scroll"
                            />

                    <b-dropdown variant="outline-primary" class="ml-2">
                        <!-- TODO exportar -->
                     <template #button-content>
                        <i class="fa fa-cloud-download" style="color: black; margin-right: 5px;"></i>
                        <span style="color: black;">Exportar</span>
                    </template>
                        <b-dropdown-item-button :disabled="loadPDF" @click="$emit('exportPDF')">
                         <i class="fa fa-file-pdf-o" v-if="!loadPDF" style="margin-right: 0px; color: black;"></i>
                            <b-spinner small v-if="loadPDF" style="margin-right: 0px; color: black;"></b-spinner>
                            Exportar PDF
                        </b-dropdown-item-button>
                        <b-dropdown-item-button :disabled="loadCSV" @click="$emit('exportCSV')">
                            <i class="fa fa-file-excel-o" v-if="!loadCSV" style="margin-right: 0px; color: black;"></i>
                            <b-spinner small v-if="loadCSV" style="margin-right: 0px; color: black;"></b-spinner>
                            Exportar CSV
                        </b-dropdown-item-button>
                        <b-dropdown-item-button :disabled="loadEF || selecteds.length <= 0" @click="$emit('showModalRelatorioEf')">
                            <i class="fa fa-cloud-download" v-if="!loadEF" style="margin-right: 0px; color: black;"></i>
                            <b-spinner small v-if="loadEF" style="margin-right: 0px; color: black;"></b-spinner>
                            Relatório para EF
                        </b-dropdown-item-button>
                    </b-dropdown>

                      <b-button class="ml-2" variant="outline-warning" style="color: #FFF" @click="$emit('exibir')" :disabled="selecteds.length !== 1">
                        <i class="fa fa-eye" style="color: black;"></i>
                        <span style="margin-left: 5px; color: black;">Exibir</span>
                    </b-button>

                     <b-button class="ml-2" variant="primary" @click="$emit('atualizarValor')" :disabled="!selecteds.length || configTable.load">
                        <i class="fa fa-refresh"></i>
                        Atualizar Valor
                   </b-button>
                </b-col>
                <b-col style="display: flex; justify-content: center;" class="my-2">
                    <div style="display: inline-block; box-sizing: border-box;" class="ml-2">
                        <b-pagination v-model="configTable.currentPage" :per-page="configTable.perPage"
                                  :total-rows="configTable.rows"
                                  v-if="configTable.perPage != 'Todos'"
                                  style="padding: 0px !important;margin-bottom: 0px !important;">
                        </b-pagination>
                    </div>
                </b-col>
                <b-col>
                    <b-form-select v-model="configTable.perPage" :options="[10, 100, 1000]" class="ml-2" style="float:right; margin-top: 8px; max-width: 100px !important;"></b-form-select>
                    <b-button class="ml-2" variant="secondary" @click="limparFiltros" style="float: right; margin-right: 5px; margin-top: 8px;">
                        <i class="fa fa-eraser"></i> Limpar Filtros
                    </b-button>
                </b-col>
            </b-row>

            <b-row class="d-flex justify-content-between" id="linhaTotais">
                <b-col>
                    <label>
                        CDAs: <strong>{{ configTable.quantidadeGeral }}</strong> / Selecionadas: <strong>{{ selecteds.length }}</strong> - Processos: <strong>{{ configTable.totalProcessos }}</strong> / Selecionados: <strong>{{ totalSelectedProcessos }}</strong> - Valor: <strong>R$ {{ configTable.totalGeral | currency }}</strong> / Seleção: <strong>R$ {{ totalSelectedValue | currency }}</strong>
                    </label>
                </b-col>
            </b-row>

            <b-table
                    id="cdasTable"
                    :items="resultado"
                    :fields="fields"
                    striped
                    small
                    responsive="sm"
                    :no-local-sorting="true"
                    :busy="configTable.load"
                    show-empty >
                <div slot="table-busy" class="text-center text-primary my-2">
                    <b-spinner class="align-middle"></b-spinner>
                    <strong> Carregando...</strong>
                </div>
                <template slot="empty">
                    <p class="my-auto">Nenhuma CDA encontrada.</p>
                </template>
                <template slot="HEAD_selecionar">
                    <b-form-checkbox v-model="configTable.checkedAll" class="justify-content-center text-center" @change="toggleAll" />
                </template>
                <template slot="selecionar" slot-scope="row">
                    <b-form-checkbox class="mx-auto justify-content-center text-center" :checked="selecteds.includes(row.item)" @change="toggleCheck($event, row.item)" />
                </template>

                <template slot="HEAD_1">
                    Número da Dívida <i class="filter coluna-fixa" :class="!isEmpty(filtros.numeroDividaSub) ? 'fa fa-filter' : 'filter-empty'" @click="openFilter('Número da Dívida', 'mascara', '', '########', $event)"></i>
                </template>
                <template slot="1" slot-scope="row">
                    <b-link @click="abrirModalExtratoCda(row.item.codCdaSefa)" class="m-0 p-0 text-center">
                        <p class="m-0 p-0"> {{row.item.numeroDivida}}</p>
                    </b-link>
                </template>
                <template slot="HEAD_2">
                    Contribuinte <i class="filter coluna-fixa" :class="!isEmpty(filtros.devedor) || filtros.filtrarDevedor == 3 ? 'fa fa-filter' : 'filter-empty'" @click="openFilter('Contribuinte', 'texto', '', null, $event)"></i>
                </template>
                <template slot="2" slot-scope="row">
                    <p class="m-0 p-0"> {{ row.item.contribuinte }} </p>

                    <template v-for="c in row.item.outrosDevedores">
                        <p class="m-0 p-0">{{ c.nome }}</p>
                    </template>
                </template>
                <template slot="HEAD_3">
                    CPF/CNPJ <i class="filter coluna-fixa" :class="!isEmpty(filtros.cpfCnpjSub) ? 'fa fa-filter' : 'filter-empty'" @click="openFilter('CPF/CNPJ', 'mascara', '', 'cpfCnpj', $event)"></i>
                </template>
                <template slot="3" slot-scope="row">
                    <p class="m-0 p-0"> {{ row.item.cpfCnpj | cpfCnpj }} </p>

                    <template v-for="c in row.item.outrosDevedores">
                        <p class="m-0 p-0">{{ c.cpfCnpjString }}</p>
                    </template>
                </template>
                <template slot="HEAD_4">
                    Tipo de Crédito <i class="filter coluna-fixa" :class="!isEmpty(filtros.tipoCredito) || filtros.filtrarTipoCredito == 3 ? 'fa fa-filter' : 'filter-empty'" @click="openFilter('Tipo de Crédito', 'texto', '', null, $event)"></i>
                </template>
                <template slot="4" slot-scope="row">
                    <p class="m-0 p-0"> {{ row.item.tipoCredito }} </p>
                </template>
                <template slot="HEAD_5">
                    Origem <i class="filter coluna-fixa" :class="!isEmpty(filtros.origem) || filtros.filtrarOrigem == 3 ? 'fa fa-filter' : 'filter-empty'" @click="openFilter('Origem', 'texto', '', null, $event)"></i>
                </template>
                <template slot="5" slot-scope="row">
                    <p class="m-0 p-0"> {{ row.item.origem }} </p>
                </template>
                <template slot="HEAD_6">
                    Tipo de Cobrança <i class="filter coluna-fixa" :class="!isEmpty(filtros.tipoCobranca) ? 'fa fa-filter' : 'filter-empty'" @click="openFilter('Tipo de Cobrança', 'checkbox', dados.tiposCobranca, null, $event)"></i>
                </template>
                <template slot="6" slot-scope="row">
                    <p class="m-0 p-0"> {{ row.item.tipoCobranca }} </p>
                </template>
                <template slot="HEAD_7">
                    Execução Fiscal <i class="filter coluna-fixa" :class="!isEmpty(filtros.cnjSub) ? 'fa fa-filter' : 'filter-empty'" @click="openFilter('Execução Fiscal', 'mascara', '', '#######-##.####.#.##.####', $event)"></i>
                </template>
                <template slot="7" slot-scope="row">
                    <b-link @click="toggleNumeroUnico(row.item.numeroUnico)" class="m-0 p-0">
                        {{ row.item.numeroUnico }}
                    </b-link>
                </template>
                <template slot="HEAD_8">
                    Assunto <i class="filter coluna-fixa" :class="!isEmpty(filtros.assunto) || filtros.filtrarAssunto == 3 ? 'fa fa-filter' : 'filter-empty'" @click="openFilter('Assunto', 'texto', '', null, $event)"></i>
                </template>
                <template slot="8" slot-scope="row">
                    <p class="m-0 p-0"> {{ row.item.assunto }} </p>
                </template>
                <template slot="HEAD_9">
                    Data Atualização <i class="filter coluna-fixa" :class="!isEmpty(filtros.dataAtualizacao) || filtros.filtrarDataAtualizacao == 5 ? 'fa fa-filter' : 'filter-empty'" @click="openFilter('Data Atualização', 'data', '', null, $event)"></i>
                </template>
                <template slot="9" slot-scope="row">
                    <p class="text-center">
                        {{ row.item.dtAtualizacao }}
                    </p>
                </template>
                <template slot="HEAD_10">
                    Valor <i class="filter coluna-fixa" :class="!isEmpty(filtros.valor) || filtros.filtrarValor == 5 ? 'fa fa-filter' : 'filter-empty'" @click="openFilter('Valor', 'numerico', '', null, $event)"></i>
                </template>
                <template slot="10" slot-scope="row">
                    <p class="m-0 p-0"> {{ row.item.valor | currency }} </p>
                </template>
                <template slot="HEAD_11">
                    Status FIR <i class="filter coluna-fixa" :class="!isEmpty(filtros.statusFir) || filtros.filtrarStatusFir == 3 ? 'fa fa-filter' : 'filter-empty'" @click="openFilter('Status FIR', 'texto', '', null, $event)"></i>
                </template>
                <template slot="11" slot-scope="row">
                    <p class="m-0 p-0"> {{ row.item.statusFir }} </p>
                </template>
                <template slot="HEAD_12">
                    Status Protesto <i class="filter coluna-fixa" :class="!isEmpty(filtros.statusProtesto) ? 'fa fa-filter' : 'filter-empty'" @click="openFilter('Status Protesto', 'checkbox', dados.listaStatusProtesto, null, $event)"></i>
                </template>
                <template slot="12" slot-scope="row">
                    <p class="m-0 p-0"> {{ row.item.statusProtesto }} </p>
                </template>
                <template slot="HEAD_13">
                    Fase CDA <i class="filter coluna-fixa" :class="!isEmpty(filtros.faseCda) ? 'fa fa-filter' : 'filter-empty'" @click="openFilter('Fase CDA', 'checkbox', dados.fasesCDA, null, $event)"></i>
                </template>
                <template slot="13" slot-scope="row">
                    <p class="m-0 p-0"> {{ row.item.faseCda }} </p>
                </template>
                <template slot="HEAD_14">
                    Ocorrência Ajuizamento <i class="filter coluna-fixa" :class="!isEmpty(filtros.ocorrenciaAjuizamento) ? 'fa fa-filter' : 'filter-empty'" @click="openFilter('Ocorrência Ajuizamento', 'checkbox', dados.ocorrenciasAjuizamento, null, $event)"></i>
                </template>
                <template slot="14" slot-scope="row">
                    <p class="m-0 p-0"> {{ row.item.ocorrenciaAjuizamento }} </p>
                </template>
                <template slot="HEAD_15">
                    Ocorrência Protesto <i class="filter coluna-fixa" :class="!isEmpty(filtros.ocorrenciaProtesto) ? 'fa fa-filter' : 'filter-empty'" @click="openFilter('Ocorrência Protesto', 'checkbox', dados.ocorrenciasProtesto, null, $event)"></i>
                </template>
                <template slot="15" slot-scope="row">
                    <p class="m-0 p-0" v-if="row.item.ocorrenciaProtesto !== null"> {{ row.item.ocorrenciaProtesto }} </p>
                    <p class="m-0 p-0" v-else-if="row.item.retornoConfirmacao !== null"> {{ row.item.retornoConfirmacao }} </p>
                    <p class="m-0 p-0" v-else-if="row.item.retornoRemessa !== null"> {{ row.item.retornoRemessa }} </p>
                </template>
                <template slot="HEAD_16">
                    Comarca <i class="filter coluna-fixa" :class="!isEmpty(filtros.comarca) || filtros.filtrarComarca == 3 ? 'fa fa-filter' : 'filter-empty'" @click="openFilter('Comarca', 'texto', '', null, $event)"></i>
                </template>
                <template slot="16" slot-scope="row">
                    <p class="m-0 p-0"> {{ row.item.comarca }} </p>
                </template>
                <template slot="HEAD_17">
                    Juízo <i class="filter coluna-fixa" :class="!isEmpty(filtros.juizo) || filtros.filtrarJuizo == 3 ? 'fa fa-filter' : 'filter-empty'" @click="openFilter('Juízo', 'texto', '', null, $event)"></i>
                </template>
                <template slot="17" slot-scope="row">
                    <p class="m-0 p-0"> {{ row.item.juizo }} </p>
                </template>
            </b-table>
        <ExtratoCda
            ref="extratoCda"
            @closeModal="closeModal" />
    </div>

</template>

<script>
    import axios from 'axios'
    import formatarMixins from '../../../mixins/formatarMixins';
    import CompBotaoExibirOcultarColuna from "../../shared/components/CompBotaoExibirOcultarColuna";
    import ExtratoCda from "../../shared/components/ExtratoCda";

    export default {
        //TODO props
    props: ['resultado', 'configTable', 'filtros', 'selecteds', 'loadPDF', 'loadCSV', 'loadEF'],
    components: {
        ExtratoCda,
        CompBotaoExibirOcultarColuna,
    },
    mixins: [ formatarMixins ],
    watch: {
        currentPage() {
            this.configTable.checkedAll = false;
            this.$emit('consultar');
        },
        perPage() {
            this.configTable.currentPage = 1;
            this.$emit('consultar');
        }

    },
    data() {
        return {
            urlApi: null,
            token: null,
            showColunms: [],
            fields: [
                {
                    key: "selecionar",
                },
            ],
            dados: {
                ocorrenciasProtesto: [],
                ocorrenciasAjuizamento: [],
                fasesCDA: [],
                tiposCobranca: [
                    {idFilter: 1, nome: "Ajuizamento"},
                    {idFilter: 0, nome: "Protesto"}
                ],
                listaStatusProtesto: [
                    {idFilter: 0, nome: 'Baixado por Pagamento'},
                    {idFilter: 1, nome: 'Baixado por Parcelamento'},
                    {idFilter: 2, nome: 'Devolvido'},
                    {idFilter: 3, nome: 'Pendente'},
                    {idFilter: 4, nome: 'Suspenso'}
                ]
            },
        }
    },
    computed: {
        currentPage() {
            return this.configTable.currentPage;
        },
        perPage() {
            return this.configTable.perPage;
        },
        totalSelectedValue() {
            let total = 0.00;
            this.selecteds.forEach(divida => {
                total = total + divida.valor
            });
            return total
        },
        totalSelectedProcessos() {
            var total = [];
            this.selecteds.forEach(divida => {
                if (total.indexOf(divida.codProcesso) < 0 && divida.codProcesso != null) {
                    total.push(divida.codProcesso);
                }
            });
            return total.length;
        },
    },
    methods: {
        async obterColunasUsuario() {
            const funcionalidade = 'consultarCda';

            axios.get(`${this.urlApi}/v1/funcionalidade/obterConfiguracao/${funcionalidade}`, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': this.token
                }
            }).then(response => {
                response.data.forEach((field, i) => {
                    if (field.ativo) {
                        this.showColunms.push(i + 1)
                    }
                    this.fields.push({
                        key: `${i + 1}`,
                        label: `${field.descricao}`,
                        thClass: field.ativo ? '' : 'd-none', tdClass: field.ativo ? '' : 'd-none',
                        codColunaFuncionalidade: field.codColunaFuncionalidade,
                        codFuncionalidade: field.codFuncionalidade
                    })
                })
            }).catch((error) => {
                this.exibirErro(error)
            })
        },

        toggleColuna(i) {
            let ativo;
            if (this.showColunms.includes(i)) {
                this.showColunms.splice(this.showColunms.indexOf(i), 1);
                this.fields[i].thClass = 'd-none';
                this.fields[i].tdClass = 'd-none';
                ativo = false
            } else {
                this.showColunms.push(i);
                this.fields[i].thClass = '';
                this.fields[i].tdClass = '';
                ativo = true
            }

            this.atualizarConfiguracaoColunm(i, ativo)
        },

        async atualizarConfiguracaoColunm(i, ativo) {
            const json = {
                codFuncionalidade: this.fields[i].codFuncionalidade,
                codColunaFuncionalidade: this.fields[i].codColunaFuncionalidade,
                ativo,
            };
            axios.post(`${this.urlApi}/v1/funcionalidade/atualizarConfiguracao`, json, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': this.token
                }
            }).catch((error) => {
                this.exibirErro(error)
            })
        },

        openFilter(campo, tipo, values, mask, event) {
            this.$emit('openFilterPopup', campo, tipo, values, mask, event);
        },
        limparFiltros() {
            this.$emit('limparFiltros');
        },
        async listarOcorrenciaProtesto() {
            axios.get(`${this.urlApi}/v1/consultarCdas/listarOcorrenciaProtesto`).then(response => {
                this.dados.ocorrenciasProtesto = response.data
            })
        },
        async listarOcorrenciaAjuizamento() {
            axios.get(`${this.urlApi}/v1/consultarCdas/listarOcorrenciaAjuizamento`).then(response => {
                this.dados.ocorrenciasAjuizamento = response.data
            })
        },
        async listarFaseCda() {
            axios.get(`${this.urlApi}/v1/consultarCdas/listarFaseCda`).then(response => {
                this.dados.fasesCDA = response.data
            })
        },

        toggleAll(checked) {
            if(checked) {
                this.resultado.forEach(el => {
                    el.checked = true;
                    if(!this.selecteds.includes(el)) {
                        this.selecteds.push(el);
                    }
                })
            } else {
                this.resultado.forEach(el => {
                    el.checked = false;
                    if(this.selecteds.includes(el)) {
                        const index = this.selecteds.indexOf(el);
                        this.selecteds.splice(index, 1);
                    }
                })
            }
        },
        toggleCheck(checked, item) {
            if(checked) {
                item.checked = checked;
                this.selecteds.push(item);
            } else {
                item.checked = checked;
                const index = this.selecteds.indexOf(item);
                this.selecteds.splice(index, 1);
                this.configTable.checkedAll = false;
            }

        },
        toggleNumeroUnico(numeroUnico) {
            let check = false;
            this.resultado.forEach(el => {
                if(el.numeroUnico == numeroUnico) {
                    if(!el.checked) {
                        check = true;
                    }
                }
            });
            this.resultado.forEach(el => {
                if(el.numeroUnico == numeroUnico) {
                    el.checked = check;
                    if(check && !this.selecteds.includes(el)) {
                        this.selecteds.push(el);
                    } else if(!check && this.selecteds.includes(el)) {
                        const index = this.selecteds.indexOf(el);
                        this.selecteds.splice(index, 1);
                        this.configTable.checkedAll = false;
                    }
                }
            });
        },
        abrirModalExtratoCda(codCdaSefa) {
            this.$refs['extratoCda'].abrirExtrato(codCdaSefa);
        },
        abrirModalExtratoCdaPorNumeroDivida(numeroDivida, codOrgaoOrigemDivida) {
            this.$refs['extratoCda'].abrirExtratoPorNumeroDivida(numeroDivida, codOrgaoOrigemDivida);
        },
        closeModal() {
            this.$emit('resetIgnorarFechar');
            this.$refs['extratoCda'].fecharModais();
            this.$emit('hideModalCdaErro');
        },
        onScroll(e) {
            var thColunas = document.getElementsByClassName("coluna-fixa")[0].parentElement.parentElement;
            var commandLine = document.getElementById("btnVoltar").parentElement.parentElement;
            var linhaTotais = document.getElementById("linhaTotais");
            if(window.scrollY <= 250) {
                commandLine.style.position = null;
                commandLine.style.top = null;
                //commandLine.style.zIndex = null;
                commandLine.classList.remove("background-scroller");

                linhaTotais.style.position = null;
                linhaTotais.style.top = null;
                //linhaTotais.style.zIndex = null;
                linhaTotais.classList.remove("background-scroller");

                thColunas.style.position = null;
                thColunas.style.top = null;
                thColunas.style.zIndex = -1;
            } else {
                commandLine.style.position = 'sticky';
                commandLine.style.top = '54px';
                commandLine.style.zIndex = 2;
                commandLine.classList.add("background-scroller");

                linhaTotais.style.position = 'sticky';
                linhaTotais.style.top = (51 + commandLine.offsetHeight) + 'px';
                linhaTotais.style.zIndex = 1;
                linhaTotais.classList.add("background-scroller");

                thColunas.style.position = 'sticky';
                thColunas.style.top = (50 + commandLine.offsetHeight + linhaTotais.offsetHeight) + 'px';
                thColunas.style.zIndex = 1;
            }
        }
    },
    mounted() {
        this.urlApi = process.env.VUE_APP_ROOT_API;
        this.token = JSON.parse(this.$store.getters.getUser).access_token;

        this.obterColunasUsuario();

        this.listarOcorrenciaProtesto();
        this.listarOcorrenciaAjuizamento();
        this.listarFaseCda();
        window.addEventListener("scroll", this.onScroll);
    },

    beforeDestroy() {
        window.removeEventListener("scroll", this.onScroll)
    },

}
</script>

<style scoped>

.no-line {
    white-space: nowrap;
}

</style>
